import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../assets/sass/dailyTotals.module.scss';
import { getWeekDateKeys } from '../../utils';

interface DailyTotalsRowProps {
  dailyTotals: Record<string, string>;
  showWeekends: boolean;
  currentWeek: Date;
}

export const DailyTotalsRow: React.FC<DailyTotalsRowProps> = ({
  dailyTotals,
  showWeekends,
  currentWeek,
}) => {
  const { t } = useTranslation();

  const dateKeys = useMemo(
    () => getWeekDateKeys(currentWeek, showWeekends),
    [currentWeek, showWeekends],
  );

  const baseDayNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  const activeDayNames = showWeekends ? baseDayNames : baseDayNames.slice(0, 5);

  return (
    <div
      className={styles.daily_totals_container}
      style={{ gridTemplateColumns: `repeat(${dateKeys.length}, 1fr)` }}
    >
      {dateKeys.map((dateKey, index) => {
        const total = dailyTotals[dateKey] || '00:00';
        const isEmpty = total === '00:00';
        const dayNameKey = activeDayNames[index] || 'monday';

        return (
          <div
            key={dateKey}
            className={`${styles.total_cell} ${isEmpty ? styles.empty : ''}`}
            title={`${t(`common.${dayNameKey}`)}: ${total}`}
          >
            <span className={styles.total_label}>{t('common.total')}:</span>
            <span className={styles.total_value}>{total}</span>
          </div>
        );
      })}
    </div>
  );
};
